import { render, staticRenderFns } from "./ComboboxModel.vue?vue&type=template&id=06003420&scoped=true&"
import script from "./ComboboxModel.vue?vue&type=script&lang=js&"
export * from "./ComboboxModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06003420",
  null
  
)

export default component.exports